import { render, staticRenderFns } from "./Svg01Section05.vue?vue&type=template&id=0d4e8a19&"
import script from "./Svg01Section05.vue?vue&type=script&lang=js&"
export * from "./Svg01Section05.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports